import L from 'leaflet';

// The "Gå till" pin in kartvy (design M1 of the "Gå till-markör" canvas, 2026-10-31): the site's own pin (the
// header logo's drop, white on the site green) where the map lands after "Gå till" or the Adress tool drops it.
// A click on the pin opens or closes the place card (PlaceCard.js). There's never more than one, and it has no ✕
// (the owner, 2026-11-01): a new one takes its place, and Map.js takes it away when the map is panned far from it.
// On a pane of its own above the area colours, the homes and the stops, so it never hides behind a marker.

export const PLACE_PIN_PANE = 'placePinPane';
const PANE_Z = 655; // above the listing markers (600), stations (640) and the stop hover pill (650); below popups

const PIN_W = 44;
const PIN_H = 41;
// The drop's tip, in the 44×41 icon (the logo's 745×689 drawing, its point at 372.6, 607.5).
const TIP = [22, 36];

// The drop's drawing (the header logo's), shared with the Adress tool's cursor (placePick.js).
export const PIN_PATHS = '<path d="M372.6,80.2c126.6,0,229.1,102.6,229.1,229.1s-229.1,295-229.1,298.2S143.5,435.9,143.5,309.3S246.1,80.2,372.6,80.2z" fill="#1f7a62" stroke="#ffffff" stroke-width="34"/>'
    + '<path d="M203.9,345c-3-12.6-4.4-25.4-4.4-38.4c0-95,80.9-167,167-167c67.8,0,130.9,44.6,157.9,112.6" fill="none" stroke="#ffffff" stroke-width="30"/>'
    + '<path d="M531.2,333.9c-15.1,91-101.1,152.6-192.2,137.4c-66.5-11-119.8-60.8-135.3-126.4" fill="none" stroke="#ffffff" stroke-width="30"/>'
    + '<path d="M532.8,344.3l-151.1-93.5c-8.4-5.2-19-5.2-27.3,0L201,344.5" fill="none" stroke="#ffffff" stroke-width="30"/>'
    + '<path d="M385.1,407.3h-39.4c-5.3,0-10.2-2.1-14.1-5.8c-3.7-3.7-5.8-8.6-5.8-13.9v-39.2c0.1-11,9-19.7,19.9-19.7h39.4c11,0,19.8,8.7,19.9,19.7v39.2C404.9,398.5,395.9,407.3,385.1,407.3z" fill="none" stroke="#ffffff" stroke-width="25"/>';
export const PIN_VIEWBOX = '-3 -3 745 689';
const PIN_SVG = `<svg class="place-pin-drop" width="${PIN_W}" height="${PIN_H}" viewBox="${PIN_VIEWBOX}" aria-hidden="true">${PIN_PATHS}</svg>`;

const escapeAttr = (value) => String(value || '').replace(/[&<>"]/g, (ch) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]));

// { show(lat, lng, label), remove(), setOpen(open), element() }. `onToggle` on a click on the pin.
export const createPlacePin = (map, { onToggle, swedish = true }) => {
    if (!map.getPane(PLACE_PIN_PANE)) {
        const pane = map.createPane(PLACE_PIN_PANE);
        pane.style.zIndex = String(PANE_Z);
    }
    let marker = null;
    let open = false;

    const icon = (label) => L.divIcon({
        className: 'place-pin',
        iconSize: [PIN_W, PIN_H],
        iconAnchor: TIP,
        html: `<button type="button" class="place-pin-button" aria-label="${escapeAttr(swedish ? `${label}: visa platsen` : `${label}: show the place`)}" aria-expanded="false">${PIN_SVG}</button>`,
    });

    const onClick = () => onToggle?.();

    const api = {
        show(lat, lng, label) {
            api.remove();
            marker = L.marker([lat, lng], {
                pane: PLACE_PIN_PANE,
                icon: icon(label),
                keyboard: false, // the buttons inside take the focus
                bubblingMouseEvents: false,
                riseOnHover: true,
            });
            marker.on('click', onClick);
            marker.addTo(map);
            api.setOpen(open);
        },
        remove() {
            if (!marker) return;
            marker.off('click', onClick);
            marker.remove();
            marker = null;
        },
        setOpen(next) {
            open = Boolean(next);
            const element = marker?.getElement();
            if (!element) return;
            element.classList.toggle('is-open', open);
            element.querySelector('.place-pin-button')?.setAttribute('aria-expanded', open ? 'true' : 'false');
        },
        element: () => marker?.getElement() || null,
    };
    return api;
};
